module.exports = __webpack_public_path__ + "static/media/DABLUE.8926d2af.png";